import {
  faSpinner,
  faMicrophone,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

import CallControls from "../CallControls";

const WaitingStatus = () => (
  <div className="text-center mb-6">
    <FontAwesomeIcon
      icon={faSpinner}
      spin={true}
      className="text-brand text-4xl mb-4"
    />
    <h3 className="text-lg font-semibold mb-2">Calling Client...</h3>
    <p>You will hear the call connect when they pick up.</p>
  </div>
);

const ConnectedStatus = () => (
  <div className="text-center mb-6">
    <FontAwesomeIcon
      icon={faMicrophone}
      spin={false}
      className="text-success text-4xl mb-4"
    />
    <h3
      className="text-lg font-semibold mb-2"
      data-testid="scribephone-connected-status"
    >
      Connected!
    </h3>
    <p>
      You are now connected to the client. The conversation is being
      recorded.
    </p>
  </div>
);

const CallStatusStep = ({
  handleEndCall,
  toggleMute,
  isMuted,
  isDialing,
  status = "waiting",
}) => {
  return (
    <>
      {status === "waiting" ? <WaitingStatus /> : <ConnectedStatus />}

      <CallControls
        handleEndCall={handleEndCall}
        toggleMute={toggleMute}
        isMuted={isMuted}
        isDialing={isDialing}
      />
    </>
  );
};

export default CallStatusStep;
